import tippy from 'tippy'
import { __ } from '@wordpress/i18n'

jQuery(document).ready(function ($) {
	$('.extra-service-wrap').slideUp(350);
	$('.wpte-expand-extra-service .scroll-down').on('click', function () {
		$('.extra-service-wrap').slideToggle();
	});
	function addCommas(nStr) {
		nStr += '';
		var x = nStr.split('.');
		var x1 = x[0];
		var x2 = x.length > 1 ? '.' + x[1] : '';
		var rgx = /(\d+)(\d{3})/;
		while (rgx.test(x1)) {
			x1 = x1.replace(rgx, '$1' + WPTE_Price_Separator + '$2');
		}
		return x1 + x2;
	}
	$('.extra-service-wrap .less-no, .extra-service-wrap .more-no').on('click', function () {
		var val = $(this).siblings('input.extra-service').val();
		if ($(this).attr('class') == 'less-no' && val == 0) return;

		if ($(this).attr('class') == 'more-no') {
			val++;
		}
		else {
			val--;
		}

		var dataid = $(this).siblings('input.extra-service').attr('data-id');
		var travelers = parseInt($('.price-holder form #trip-cost').val());
		var cost = parseInt($('.extra-service-cost[data-id="' + dataid + '"]').attr('data-cost'));
		var service = val * cost;
		$('.service-temporary[data-id="' + dataid + '"]').val(service);
		var service_cost = 0;
		$('.service-temporary').each(function () {
			if ($(this).val() != 0) {
				service_cost += parseInt($(this).val());
			}
		});
		var tcost = travelers + service_cost;
		$('.total-amt .total').html(addCommas(tcost));
	});

	$('body').on('change', '.travelers-no', function (e) {
		$val = $(this).val();
		$new_val = $('.hidden-price').first().text().replace(/,/g, '');
		$total = $val * $new_val;
		$service_cost = 0;
		$('#trip-cost').val($total);

		$('.extra-service').each(function () {
			var val = $(this).val();
			var dataid = $(this).attr('data-id');
			var cost = parseInt($('.extra-service-cost[data-id=' + dataid + ']').attr('data-cost'));
			var service = val * cost;
			$('.service-temporary[data-id="' + dataid + '"]').val(service);
			$service_cost = 0;
			$('.service-temporary').each(function () {
				if ($(this).val() != 0) {
					$service_cost += parseInt($(this).val());
				}
			});
		});

		$total = $total + $service_cost;
		$total = addCommas($total);
		$('.total').html(addCommas($total));
	});

	if ($('.wte-extra-services-row').length > 0) {

		if ($('.wte-es-item-name').length === 0) {

			$('.wte-extra-services-row').hide();

		}

	}

	/**
	 * Handle the extra services increment and decrement single trip page booking form.
	 */
	jQuery('.wpte-bf-step-content-extra-services .wpte-bf-number-field').each(function () {
		var spinner = jQuery(this),
			input = spinner.find('input[type="text"]'),
			btnUp = spinner.find('.wpte-bf-plus'),
			btnDown = spinner.find('.wpte-bf-minus'),
			min = input.attr('min'),
			max = input.attr('max');

		btnUp.click(function (event) {
			event.preventDefault();

			var value = parseInt(input.val());
			++value;

			// Don't let the value increase greater than the maximum value.
			if (value >= max) {
				value = max;
			}

			spinner.find('input').val(value);
			spinner.find('input').trigger('change');

			populateTheExtraServicesCost();
		});

		btnDown.click(function (event) {

			event.preventDefault();

			var value = parseInt(input.val());
			--value;

			// Don't let the value increase greater than the maximum value.
			if (value <= min) {
				value = min;
			}

			spinner.find('input').val(value);
			spinner.find('input').trigger('change');

			populateTheExtraServicesCost();
		});
	});

	/**
	 * Populate the extra services cost.
	 */
	function populateTheExtraServicesCost() {
		var extraServicesList = [];

		// Calculate total.
		var extraServicesTotalCost = calculateExtraServicesTotalCost();
		window.wte.trip.extraServicesCost = extraServicesTotalCost;
		var grandTotal = calculateGrandTotal();
		var formattedGrandTotal = wteGetFormatedPrice(grandTotal, wte.currency.code);
		var formattedGrandTotalWithCodeSymbol = wteGetFormatedPriceWithCurrencyCodeSymbol(grandTotal, wte.currency.code, wte.currency.symbol);

		// Calculate extra service cost and generate the HTML.
		var numberFields = $('.wpte-bf-step-content-extra-services .wpte-bf-number-field input[type="text"]');
		var html = '';

		$.each(numberFields, function (index, numberField) {
			var serviceCost = calculateServiceCost(numberField);
			var serviceCostFormatted = wteGetFormatedPriceWithCurrencyCodeSymbol(serviceCost, wte.currency.code, wte.currency.symbol);
			var unit = $(numberField).data('unit');
			var count = parseInt($(numberField).val());
			var servicePrice = numberField.dataset.cost
			var servicePriceFormatted = wteGetFormatedPriceWithCurrencyCodeSymbol(servicePrice, wte.currency.code, wte.currency.symbol);
			var extraService = $(numberField).parents('.wpte-bf-traveler').find('span').html();

			// Don't create html for the services with zero count.
			if (count === 0) {
				return true;
			}

			// Create extra services list.
			extraServicesList.push({
				'extra_service': extraService,
				'qty': count,
				'price': servicePrice,
				'id': parseInt( numberField.dataset.serviceId || 0, 10 ),
			});


			html += `
				<tr>
					<td>
					${count} x ${extraService} <span class="wpte-bf-info">(${servicePriceFormatted}/${unit})</span>
					</td>
					<td>
					${serviceCostFormatted}
					</td>
				</tr>
			`;
		});

		// Update the trip cost.
		window.wteCartFields['trip-price'] = grandTotal;

		// Add the extra services list to the cart.
		window.wteCartFields['extra_service'] = extraServicesList;

		// Update the extra services cost.
		$('.wpte-bf-extra-serivce-price-table tbody').html(html);


		// Update the grand total.
		$('.wpte-bf-total-price > .wpte-price').html(formattedGrandTotal);
		$('.wte-bf-price-detail .wpte-bf-total').html(`
			${__('Total:', 'wte-extra-services')} <b>${formattedGrandTotalWithCodeSymbol}</b>
		`);

		// Display the price table if the service cost is greater than zero.
		if (extraServicesTotalCost === 0) {
			$('.wpte-bf-extra-serivce-price-table').css('display', 'none');
		} else {
			$('.wpte-bf-extra-serivce-price-table').css('display', '');
		}
	}

	/**
	 * Calculate total extra services cost.
	 */
	function calculateExtraServicesTotalCost() {

		// Get all the number input fields.
		var numberFields = $('.wpte-bf-step-content-extra-services .wpte-bf-number-field input[type="text"]')
		var total = 0.0;

		$.each(numberFields, function (index, numberField) {
			var extraServiceCost = calculateServiceCost(numberField);
			total = total + extraServiceCost;
		});

		return total;
	}

	/**
	 *
	 * @param {jQueryObject} numberField jQuery object for the extra service input field.
	 */
	function calculateServiceCost(numberField) {
		var count = parseInt($(numberField).val());
		var cost = parseFloat(numberField.dataset.cost);
		total = count * cost;

		return total;
	}

	// Custom blocks.
	let customESBlocks = document.querySelectorAll('.wpte-bf-es-custom-block')

	customESBlocks?.forEach(cb => {
		let memberInput = cb.querySelector('[name=add-member]')
		let prices = cb.dataset?.servicePrices ? JSON.parse(cb.dataset.servicePrices) : []
		let options = cb.dataset?.serviceOptions ? JSON.parse(cb.dataset.serviceOptions) : []
		let serviceTitle = cb.dataset?.serviceTitle ? cb.dataset.serviceTitle : ''
		let optionSelect = cb.querySelector('.services-options-select')
		let priceHolder = cb.querySelector('.wpte-price')
		let titleHolder = cb.querySelector('.wpte-bf-service-name')
		optionSelect?.addEventListener('change', e => {
			let cost = prices[e.target.value] ? +prices[e.target.value] : 0
			memberInput.dataset.cost = cost
			if (typeof priceHolder !== 'undefined') priceHolder.innerHTML = cost
			if (typeof titleHolder !== 'undefined') titleHolder.innerHTML = `${serviceTitle} (${options[e.target.value]})`
			populateTheExtraServicesCost()
		})
	})

	if (window.tippy) {
		document.addEventListener( 'wteLoadBookingTemplates', () => {
			let esContainer = document.getElementById('wte-booking-extraservices')
			esContainer.addEventListener('mouseenter', function() {
				tippy('.wte-meta-help', {
					content: ref => ref.querySelector('.wte-help-content')?.textContent,
					placement: 'auto',
					touch: true,
					zIndex: 99999999,
				});
			})
			// esContainer.addEventListener('mouseenter', function() {
			// 	tippy('.wte-es-with-multiple-options .wte-meta-help', {
			// 		content: ref => ref.querySelector('.wte-help-content')?.textContent,
			// 		placement: 'auto',
			// 		touch: true,
			// 		zIndex: 99999999,
			// 	});
			// })
		} );
	}

});
